export const extractErrorMessage = (error: unknown): string => {
  if (error instanceof Error) {
    try {
      const errors = JSON.parse(error.message);
      return errors[0].message;
    } catch {
      return error.message;
    }
  } else if (typeof error === 'object') {
    return JSON.stringify(error);
  } else {
    return `${error}`;
  }
};
